// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".segmented-colored-progressbar[data-v-3283aece]{display:flex;flex-direction:column;align-items:stretch;width:100%;row-gap:16px}.segmented-colored-progressbar__bar[data-v-3283aece]{display:flex;align-items:stretch;height:32px;column-gap:1px;overflow:hidden;border-radius:32px;border:1px solid #e5e5e5}.segmented-colored-progressbar__bar_progress[data-v-3283aece]{width:10%;height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
